import { Component, OnInit, Input } from '@angular/core';
import * as shape from 'd3-shape';
import { customColorSets } from '../../../neu-charts/utils/custom-color-sets';
import { DirectedGraph } from '../../utils/models/directed-graph';

@Component({
    selector: 'neu-directed-graph',
    template: `<div *ngIf="data && data['links'] && data['nodes']" class="chart-container">
    <ngx-graph class="chart-container" 
        [links]="data['links']"
        [nodes]="data['nodes']"
        [scheme]="colorScheme"
        [view]="options.view" 
        [legend]="options.showLegend"
        [orientation]="options.orientation" 
        [curve]="curve"
        [autoCenter]="options.autoCenter"
        [autoZoom]="options.autoZoom"
        (select)="mOnSelect($event)">

        <ng-template #defsTemplate>
            <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4" orient="auto">
                <svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
            </svg:marker>
        </ng-template>

        <ng-template #nodeTemplate let-node>
            <svg:g class="node">
                <!-- ngx-tooltip [tooltipPlacement]="'top'" [tooltipType]="'tooltip'" [tooltipTitle]="node.label"> -->
                <svg:rect [attr.width]="node.width" [attr.height]="node.height" [attr.fill]="node.options.color" />
                <svg:text alignment-baseline="central" [attr.x]="10" [attr.y]="node.height / 2">{{node.label}}</svg:text>
            </svg:g>
        </ng-template>

        <ng-template #linkTemplate let-link>
            <svg:g class="edge">
                <svg:path 
                    class="line"
                    stroke-width="2" 
                    marker-end="url(#arrow)">
                </svg:path>
                <svg:text class="edge-label" text-anchor="middle">
                    <textPath class="text-path" 
                        style="fill: #666;"
                        [attr.href]="'#' + link.id" 
                        [style.dominant-baseline]="link.dominantBaseline" 
                        startOffset="50%">
                        {{link.label}}
                    </textPath>
                </svg:text>
            </svg:g>
        </ng-template>

    </ngx-graph>
</div>
<no-data *ngIf="(!data) || (!data['links']) || (!data['nodes'])"></no-data>`,
    styles: [``]
})
export class DirectedGraphComponent implements OnInit {

    @Input() data: any;
    @Input('options') customOptions: DirectedGraph;
    
    options: DirectedGraph = new DirectedGraph;
    curve = shape.curveBundle;
    colorScheme = customColorSets.find(s => s.name == 'palatte');

    constructor() { }

    ngOnInit() {
        Object.assign(this.options, this.customOptions);
    }

    mOnSelect(event) {
        console.log('clicked', event);
    }

}
